import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import connectComponent from "../../redux/connectComponent";
import OtpAuth from "./otpAuth";

export class OtpShow extends PureComponent {
  static propTypes = {
    actions: PropTypes.object,
    database: PropTypes.object,
    location: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.state = {
      authed: false,
      incomplete: false,
      user: null
    };
  }

  onAuth = () => this.setState({ authed: true });

  // Definitely authenticated but need more - pass user data for UpdateInfo
  onIncomplete = (user) => this.setState({ incomplete: true, user });

  registrationPath = () => `/registration`;

  render() {
    // If user is incomplete (missing street, phone, or postal_code), send to update_info
    // Pass user data directly via location state to avoid Redux timing issues
    if (this.state.incomplete) {
      return (
        <Redirect
          to={{
            pathname: "/session/update_info",
            state: { user: this.state.user }
          }}
        />
      );
    }

    if (this.state.authed) {
      return (
        <Redirect to={this.props.location.state?.referrer || "/dashboard"} />
      );
    }

    return (
      <OtpAuth
        onAuth={this.onAuth}
        onIncomplete={this.onIncomplete}
        registrationPath={
          !this.props.location.state?.checkout && this.registrationPath()
        }
        referrer={this.props.location.state?.referrer}
      />
    );
  }
}

export default connectComponent(OtpShow, ["authentication"]);
